<template>
  <div @mousewheel="mousewheel">
    <!-- <div class="point" v-if="ponitShow" @mouseleave="handlerMouseover"> -->
    <div class="point" v-show="isShow1" @mouseleave="mouseleave">
      <div>
        <div
          :class="{ 'active-scroll': code == index }"
          @click="handlerClickId(item)"
          v-for="(item, index) in pointList"
          :key="item.code"
          style="cursor: pointer"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="nav_box">
      <div class="spaceline"></div>
      <div id="sszmqBox">
        <div
          class="m-wrapper"
          style="border-radius: 0; box-shadow: none; height: 580px"
        >
          <div class="titleBox">
            <span class="bigTitleInfo">Provincial/Municipal FTZs</span>
          </div>
          <div class="splitLine"></div>

          <div class="filter-wrapper clearfix">
            <div class="inner clearfix">
              <div class="form">
                <el-select
                  filterable
                  popper-class="select-down"
                  size="small"
                  v-model="province"
                  placeholder="select"
                  @change="provinceChange"
                >
                  <el-option
                    v-for="item in provinceList"
                    :key="item.id"
                    :label="item.val"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="form">
                <el-select
                  filterable
                  size="small"
                  v-model="city"
                  placeholder="select"
                  popper-class="select-down"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.id"
                    :label="item.val"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div @click="handleClick" class="confirm-button">Go</div>
            </div>
          </div>

          <div
            v-loading="loading"
            style="
              height: 510px;
              border-radius: 0 0 20px 20px;
              overflow: hidden;
              position: relative;
              top: -70px;
              z-index: 1;
            "
          >
            <div class="mapDiv">
              <div>
                <p>{{ cityName }}</p>
              </div>
              <div class="titleMap">
                <span>Legend：</span>
                <img :src="iconUrl" />
                <span>Area</span>
              </div>
              <tdt-map
                ref="map"
                :center="center"
                :zoom="zoom"
                :drag="false"
                :scrollWheelZoom="false"
                :doubleClickZoom="false"
                :keyboard="false"
                :inertia="false"
                :continuousZoom="false"
                :pinchToZoom="false"
              >
                <tdt-label
                  :position="center"
                  :text="text"
                  :offset="[-105, -125]"
                ></tdt-label>
                <tdt-marker :position="center" :icon="icon"></tdt-marker>
              </tdt-map>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav_box" v-if="isShowItem">
      <div class="spaceline"></div>
      <div
        class="top"
        style="border-radius: 0px; margin-bottom: 0"
        :style="{ height: isShowItem == 1 ? '300px' : '' }"
      >
        <div class="titleBox">
          <span class="bigTitleInfo">Area Info</span>
        </div>
        <div class="splitLine"></div>
        <div class="top_box">
          <div
            class="top_box_item"
            v-if="information.introduction && information.introduction.length"
          >
            <div class="item_title">Area Profile</div>
            <div class="item_hoverheight" v-if="information.introduction">
              <div
                style="
                  text-indent: 2em;
                  padding: 5px 10px;
                  font-size: 12px;
                  color: #474747;
                "
                v-for="(item, index) in information.introduction"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
            <div class="noData" style="height: 155px !important" v-else>
              No Data
            </div>
          </div>
          <div
            class="top_box_item"
            v-if="information.indsStrategy && information.indsStrategy.length"
          >
            <div class="item_title">Key Industry</div>
            <div
              class="item_hoverheight"
              v-if="information.indsStrategy && information.indsStrategy.length"
            >
              <div class="detail-3">
                <div
                  class="item"
                  :key="index"
                  v-for="(item, index) in information.indsStrategy"
                >
                  <img
                    style="margin-right: 13px"
                    width="15"
                    height="16"
                    :src="iconPath"
                    alt=""
                  />
                  <span>{{ item }}</span>
                </div>
              </div>
            </div>
            <div class="noData" style="height: 155px !important" v-else>
              No Data
            </div>
          </div>
          <div
            class="top_box_item"
            v-if="
              information.strategicOrientation &&
              information.strategicOrientation.length
            "
          >
            <div class="item_title">Strategic Positioning</div>
            <div
              class="item_hoverheight"
              v-if="information.strategicOrientation"
            >
              <div
                style="
                  text-indent: 2em;
                  padding: 10px;
                  font-size: 12px;
                  color: #474747;
                "
              >
                {{ information.strategicOrientation }}
              </div>
            </div>
            <div class="noData" style="height: 155px !important" v-else>
              No Data
            </div>
          </div>
          <div
            class="top_box_item"
            v-if="information.geography && information.geography.length"
          >
            <div class="item_title">Geographical Position</div>
            <div class="item_hoverheight" v-if="information.geography">
              <div
                style="
                  text-indent: 2em;
                  padding: 5px 10px;
                  font-size: 12px;
                  color: #474747;
                "
                v-for="(item, index) in information.geography"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
            <div class="noData" style="height: 155px !important" v-else>
              No Data
            </div>
          </div>
          <div
            class="top_box_item"
            v-if="
              information.climateCondition &&
              information.climateCondition.length
            "
          >
            <div class="item_title">Climate</div>
            <div class="item_hoverheight" v-if="information.climateCondition">
              <div
                style="
                  text-indent: 2em;
                  padding: 5px 10px;
                  font-size: 12px;
                  color: #474747;
                "
                v-for="(item, index) in information.climateCondition"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
            <div class="noData" style="height: 155px !important" v-else>
              No Data
            </div>
          </div>
          <div
            class="top_box_item"
            v-if="information.publicFaci && information.publicFaci.length"
          >
            <div class="item_title">Supporting Infrastructure</div>
            <div class="item_hoverheight" v-if="information.publicFaci">
              <div
                style="
                  text-indent: 2em;
                  padding: 5px 10px;
                  font-size: 12px;
                  color: #474747;
                "
                v-for="(item, index) in information.publicFaci"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
            <div class="noData" style="height: 155px !important" v-else>
              No Data
            </div>
          </div>
        </div>
        <!--      <div class="top_box">
        <div class="top_box_item">
          <div class="item_title">片区基本信息</div>
          <div class="item_hoverheight">
            <vue-scroll :ops="scrollOption" v-if="information.introduction">
              <div class="aab" style="position: relative">
                <div
                  style="
                  text-indent: 2em;
                  padding: 5px 10px;
                  font-size: 12px;
                  color: #474747;
                "
                  v-for="(item, index) in information.introduction"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>

            </vue-scroll>
            <div class="noData" v-else>No Data</div>
          </div>
        </div>
        <div class="top_box_item">
          <div class="item_title">重点产业</div>
          <div style="height: 155px">
            <vue-scroll
              :ops="scrollOption"
              v-if="information.indsStrategy && information.indsStrategy.length"
            >
              <div class="detail-3">
                <div
                  class="item"
                  :key="index"
                  v-for="(item, index) in information.indsStrategy"
                >
                  <img
                    style="margin-right: 13px"
                    width="15"
                    height="16"
                    :src="iconPath"
                    alt=""
                  />
                  <span>{{ item }}</span>
                </div>
              </div>
            </vue-scroll>
            <div class="noData" v-else>No Data</div>
          </div>
        </div>
        <div class="top_box_item">
          <div class="item_title">战略定位</div>
          <div style="height: 155px">
            <vue-scroll
              :ops="scrollOption"
              v-if="information.strategicOrientation"
            >
              <div
                style="
                  text-indent: 2em;
                  padding: 10px;
                  font-size: 12px;
                  color: #474747;
                "
              >
                {{ information.strategicOrientation }}
              </div>
            </vue-scroll>
            <div class="noData" v-else>No Data</div>
          </div>
        </div>
        <div class="top_box_item">
          <div class="item_title">地理位置</div>
          <div style="height: 155px">
            <vue-scroll :ops="scrollOption" v-if="information.geography">
              <div
                style="
                  text-indent: 2em;
                  padding: 5px 10px;
                  font-size: 12px;
                  color: #474747;
                "
                v-for="(item, index) in information.geography"
                :key="index"
              >
                {{ item }}
              </div>
            </vue-scroll>
            <div class="noData" v-else>No Data</div>
          </div>
        </div>
        <div class="top_box_item">
          <div class="item_title">气候条件</div>
          <div style="height: 155px">
            <vue-scroll :ops="scrollOption" v-if="information.climateCondition">
              <div
                style="
                  text-indent: 2em;
                  padding: 5px 10px;
                  font-size: 12px;
                  color: #474747;
                "
                v-for="(item, index) in information.climateCondition"
                :key="index"
              >
                {{ item }}
              </div>
            </vue-scroll>
            <div class="noData" v-else>No Data</div>
          </div>
        </div>
        <div class="top_box_item">
          <div class="item_title">公告配套信息</div>
          <div style="height: 155px">
            <vue-scroll :ops="scrollOption" v-if="information.publicFaci">
              <div
                style="
                  text-indent: 2em;
                  padding: 5px 10px;
                  font-size: 12px;
                  color: #474747;
                "
                v-for="(item, index) in information.publicFaci"
                :key="index"
              >
                {{ item }}
              </div>
            </vue-scroll>
            <div class="noData" v-else>No Data</div>
          </div>
        </div>
      </div>-->
      </div>
    </div>
    <div class="nav_box">
      <div class="spaceline"></div>
      <div
        :class="
          flag &&
          information.contactInfo &&
          information.contactInfo.length === 0
            ? 'downA'
            : 'down'
        "
        style="margin-bottom: 18px"
      >
        <div :class="flag ? 'boxA' : 'boxB'">
          <div
            class="down_left down_"
            style="border-radius: 0px; height: auto; padding-bottom: 10px:"
            v-if="innovateList.length > 0"
          >
            <div class="titleBox">
              <span class="bigTitleInfo">Key Colleges and Universities</span>
            </div>
            <div class="splitLine"></div>
            <div class="down_body">
              <vue-scroll
                :ops="scrollOption"
                v-if="innovateList && innovateList.length"
              >
                <div v-for="(item, index) in innovateList" :key="index">
                  <div class="down_body_item" v-if="item.phoneNum || item.addr">
                    <div class="left">
                      <div class="index">{{ index + 1 }}</div>
                      <!--                <img src="../../../assets/images/fta/fta-icon-addr.png" height="16" width="16"/>-->
                    </div>
                    <div class="right">
                      <div class="right_title">{{ item.college }}</div>
                      <div class="right_image" v-if="item.phoneNum">
                        <div class="right_one">
                          <img
                            src="../../../assets/images/fta/fta-icon-phone.png"
                          />
                        </div>
                        <div class="right_two">
                          <p v-for="(child, i) in item.phoneNum" :key="i">
                            {{ child }}
                          </p>
                        </div>
                      </div>
                      <div class="right_image1" v-if="item.addr">
                        <div class="right_one">
                          <img
                            src="../../../assets/images/fta/fta-icon-addr.png"
                          />
                        </div>
                        <div class="right_two">{{ item.addr }}</div>
                      </div>
                      <!--              <div class="content"></div>-->
                    </div>
                  </div>
                </div>
              </vue-scroll>
              <div class="nodata" v-else>No Data</div>
            </div>
          </div>
        </div>

        <div
          :class="
            information.contactInfo && information.contactInfo.length === 0
              ? 'boxA'
              : 'boxB'
          "
        >
          <div
            class="down_right down_"
            style="border-radius: 0px; height: auto; padding-bottom: 10px"
            v-if="information.contactInfo && information.contactInfo.length"
          >
            <div class="titleBox">
              <span class="bigTitleInfo">Contact</span>
            </div>
            <div class="splitLine"></div>
            <div style="height: 480px">
              <!-- <vue-scroll
              :ops="scrollOption"
              v-if="newsList && newsList.length"
              @handle-scroll="handleScroll"
            >
              <div class="right_body" ref="bing">
                <div
                  class="right_body_wrapper"
                  v-for="(item, index) in newsList"
                  :key="index"
                >
                  <div class="down_right_title" @click="handleNewsClick(item)">
                    {{ item.title }}
                  </div>
                  <div class="down_right_body">
                    {{ item.description }}
                  </div>
                <div class="down_right_foot">
                  <div class="left">
                    <div class="btnn">{{ item.catName }}</div>
                  </div>
                  <div class="right">
                    {{ published(item.published) }}
                  </div>
                </div>
                </div>
              </div>
            </vue-scroll>
            <div class="nodata" v-else>No Data</div> -->
              <div
                class="list"
                style="padding: 0px 30px"
                v-if="information.contactInfo"
              >
                <div
                  class="item"
                  style="font-size: 14px"
                  v-for="(item, index) in information.contactInfo"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
              <div class="list" style="font-size: 14px" v-else>No Data</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav_box" id="lxxxBox" v-if="false">
      <div class="foot" style="border-radius: 0px; margin-top: 0">
        <div class="titleBox">
          <span class="bigTitleInfo">Contact</span>
        </div>
        <div class="splitLine"></div>
        <div class="contact-info-wrapper">
          <div class="inner">
            <div class="left-content">
              <img :src="icon1" alt="" />
            </div>
            <div class="contact-info" id="lxxxRightInfo">
              <vue-scroll :ops="scrollOption">
                <div class="list" v-if="information.contactInfo">
                  <div
                    class="item"
                    style="color: #ffffff; font-size: 14px"
                    v-for="(item, index) in information.contactInfo"
                    :key="index"
                  >
                    {{ item }}
                  </div>
                </div>
                <div
                  class="list"
                  style="color: #ffffff; font-size: 14px"
                  v-else
                >
                  No Data
                </div>
              </vue-scroll>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="Notes"
      :center="true"
      :visible.sync="dialogVisible"
      width="1194px"
    >
      <div class="box">
        <div style="font-size: 14px">Published:{{ InfoList.time }}</div>
        <div v-html="InfoList.content"></div>
      </div>
      <div slot="title" class="dialog-title">
        <h2
          style="font-size: 23px; color: #000; font-weight: 500"
          v-html="InfoList.title"
        ></h2>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FtaHeader from "../component/FtaHeader";
import { VUE_SCROLL_OPTION } from "../../../ftaUtils/config";
import request from "../../../ftaUtils/http";
import baseUrl from "../../../ftaUtils/baseUrl";
import FtaTable from "../component/FtaTable";
import ChartBar from "../component/__ChartBar";
import ChartLine from "../component/ChartLine";
import ChartPie from "../component/ChartPie";
import FtaTitle from "../component/FtaTitle";
import moment from "moment";
import { getCookieKey } from "../../../ftaUtils/util";
import { locale } from "view-design";

export default {
  name: "FtaAreaInfo",
  components: {
    FtaHeader,
    FtaTable,
    ChartBar,
    ChartLine,
    ChartPie,
    FtaTitle,
  },
  data() {
    return {
      flag: false,
      loading: true,
      journalismInfo: {
        state: true,
        data: {
          id: 320891,
          title:
            "SW. China's Chongqing to deepen economic and trade cooperation with ASEAN",
          editor: "Hu Pingchao",
          has_thumb: 1,
          published: "2021-04-13 17:24:26",
          appid: 1,
          is_pay: 0,
          price: 0,
          category_name: "News for Outlets",
          description:
            "Southwest China's Chongqing Municipality has recently unveiled an action plan for deepening economic and trade cooperation with the ASEAN countries from 2021 to 2025, according to the Chongqing Municipal Commission of Commerce on Tuesday.",
          thumb:
            "https://img.imsilkroad.com/a/icmp/2021/04/13/2021041352840432/73a76f4ab67c4899966b285740adf196.png",
          content:
            '<p style="text-align: center;"><img imagerela="2804951" src="https://img.imsilkroad.com/a/icmp/2021/04/13/2021041352840432/abf885be08924b6a8707f6fd43dfa72b.png" title="Chongqing.png" alt="Chongqing.png"></p>\n<p>Photo taken on April 26, 2019 shows the first "new international land-sea trade corridor" rail-ocean intermodal train bound for Indonesia in southwest China\'s Chongqing. (Xinhua/Liu Chan)</p>\n<p>BEIJING, April 13 (Xinhua) -- Southwest China\'s Chongqing Municipality has recently unveiled an action plan for deepening economic and trade cooperation with the ASEAN countries from 2021 to 2025, according to the Chongqing Municipal Commission of Commerce on Tuesday.&nbsp;</p>\n<p>According to the action plan, Chongqing targets more than 20 billion U.S. dollars worth of trade volume of goods with ASEAN and over 15 billion U.S. dollars of investment from the ASEAN countries in actual use, by 2025.&nbsp;</p>\n<p>Meanwhile, Chongqing aims to bring its implementation of service outsourcing from ASEAN countries to more than 500 million U.S. dollars, and the number of Chongqing-funded enterprises in the ASEAN countries to more than 150 by 2025, said the plan.&nbsp;</p>\n<p>An official of the Chongqing Municipal Commission of Commerce said that in 2019 and 2020, ASEAN had been Chongqing\'s largest trading partner for two consecutive years. In 2020, the import and export volume with ASEAN countries was 112.17 billion yuan, accounting for 18.1 percent of the city\'s total import and export volume. As of the end of 2020, the amount of the foreign capital from ASEAN countries in actual use had been 12.51 billion U.S. dollars for Chongqing.&nbsp;</p>\n<p>In fact, many enterprises in Chongqing have taken root in the ASEAN countries. In 2014, the Chongqing-based Sokon Group selected Indonesia as its first choice for overseas investment. Since the completion of its plant in Indonesia in 2018, the company has formed a "3+1" product system in Indonesia with three SUV models and one "super cab" model.&nbsp;</p>\n<p>The introduction of the action plan will help Chongqing seize the major opportunities brought by the Regional Comprehensive Economic Partnership (RCEP) to accelerate opening-up of the inland areas, according to Fang Chaojun, Associate Professor of Chongqing Finance and Economics College. (Edited by Hu Pingchao with Xinhua Silk Road, hupingchao@xinhua.org)</p>',
          keyword: ["Chongqing", "ASEAN", "RCEP"],
          author: ["Hu Pingchao"],
          source: "Xinhua Silk Road",
          isCollect: 0,
          isDigg: 0,
          attachment: [],
          space: null,
        },
      },
      isShow1: false,
      code: "0",
      ponitShow: false,
      pointList: [
        { name: "Provincial/Municipal FTZs", code: 0, id: "#Provincial" },
        { name: "Area Info", code: 1, id: "#industry" },
        { name: "Key Colleges and Universities", code: 2, id: "#economic" },
        // { name: 'News On All FTZs', code: 3, id: '#development-of' },
        // { name: "Contact", code: 3, id: "#investment" }
      ],
      dialogVisible: false,
      InfoList: {
        title: "",
        time: "",
        content: "",
      },
      iconPath: require("../../../assets/images/fta/icon1.png"),
      icon1: require("../../../assets/images/fta/bg3.png"),
      scrollOption: VUE_SCROLL_OPTION,
      year: null,
      province: null,
      city: null,
      center: [121.373237, 31.273094],
      zoom: 10,
      yearList: [],
      provinceList: [],
      cityList: [],
      markerArr: [],
      cityName: "",
      text: "",
      icon: {
        iconUrl: require("@/assets/images/biaodian.svg"),
        iconSize: [18, 26],
        iconAnchor: [9, 26],
      },
      iconUrl: require("../../../assets/images/biaodian.svg"),
      options: [],
      options1: [],
      options2: [],
      ftaId: "",
      areaId: "",
      statYear: "",
      Info: "info",
      Inn_resources: "inn_resources",
      information: {},
      isShow: "0",
      newsList: [],
      innovateList: [],
      innovateColumn: [
        {
          prop: "num",
          label: "S/N",
          width: "180px",
          align: "center",
          color: "#3447FF",
        },
        {
          prop: "college",
          label: "College name",
          width: "600px",
          align: "center",
        },
        {
          prop: "addr",
          label: "College (Institution) address",
          align: "center",
        },
        {
          prop: "phoneNum",
          label: "Phone",
          align: "center",
        },
      ],
      newsColumn: [
        { prop: "title", label: "title", width: "1100px", align: "center" },
        {
          prop: "published",
          label: "Date",
          align: "center",
          width: "540px",
          color: "#3447FF",
        },
      ],
      scrollStar: true,
      keyword: "policy",
      page: 1,
      total: 0,
      isLoading: false,
      slideOpt: {
        vvuescroll: {
          mode: "slide",
          sizeStrategy: "percent",
          detectResize: true,
          /** 锁定一种滚动方向， 锁定的方向为水平或者垂直方向上滑动距离较大的那个方向 */
          locking: true,
        },
      },
      isShowItem: 2,
    };
  },
  methods: {
    handleScroll(vertical, horizontal, nativeEvent) {
      const isHeight = this.$refs.bing.clientHeight - vertical.scrollTop - 492;
      if (isHeight < 30) {
        if (this.page * 20 < this.total && this.isLoading == false) {
          this.isLoading = true;
          this.page = this.page + 1;
          // this.changePage();
        }
      }
    },
    changePage() {
      let that = this;
      //   新闻
      request("get", `${baseUrl.base_3}/api/tags/FTZ?page=${this.page}`)
        .then((res) => {
          this.total = res.data.total;
          let list = res.data.content;
          list.forEach((item, index) => {
            item.num = index + 1;
            // item.keyword = item.catName
            item.keyword = this.keyword;
          });
          this.newsList = [...this.newsList, ...list];
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err, "err");
          that.isLoading = false;
        });
    },
    // 修改 数据
    phoneNumFtn(item) {
      item = item + "";
      // if(item.indexOf('&') > -1){
      //   //  return item.split('&');
      // }
      return [];
    },
    mouseleave() {
      this.isShow1 = false;
    },
    mousewheel() {
      this.isShow1 = true;
    },
    handlerMouseover() {
      this.ponitShow = false;
    },
    handlerClickId(item) {
      this.$emit("scrollId", item.code);
      // this.code = item.code;
    },
    handleNewsClick(data) {
      this.dialogVisible = true;
      // const id = data.resourceId.split('_')[1]
      const id = data.id;
      //  没有cookie 的假数据
      // this.InfoList.title = this.journalismInfo.data.title
      // this.InfoList.time = this.journalismInfo.data.published
      // const content = '<div style="padding:12px 20px;font-size: 14px;color: ' +
      //         '#4f5362;background: #E8EAEF;margin-bottom: 30px;width: 98%"><div>' + this.journalismInfo.data.description + '</div></div>' + '<div>' + this.journalismInfo.data.content + '</div>' +
      //         '<div style="margin-top: 20px;font-size: 12px;color: #80828d">' + 'Editor：' + this.journalismInfo.data.editor + '</div>'
      // const text = content.replace('<img','<img style="display:block;width:70%;margin:0 auto"')
      // this.InfoList.content = text

      // this.$http
      //   .post(`${baseUrl.base_3}/api/pc/getarticledetail`, {
      //     id: id
      //   })
      request("post", `${baseUrl.base_3}/api/pc/getarticledetail`, {
        id: id,
      }).then((res) => {
        this.InfoList.title = res.data.data.title;
        this.InfoList.time = res.data.data.published;
        const content =
          '<div style="padding:12px 20px;font-size: 14px;color: ' +
          '#4f5362;background: #E8EAEF;margin-bottom: 30px;width: 98%"><div>' +
          res.data.data.description +
          "</div></div>" +
          "<div>" +
          res.data.data.content +
          "</div>" +
          '<div style="margin-top: 20px;font-size: 12px;color: #80828d">' +
          "Editor：" +
          res.data.data.editor +
          "</div>";
        const text = content.replace(
          "<img",
          '<img style="display:block;width:70%;margin:0 auto"'
        );

        this.InfoList.content = text;
      });
    },

    provinceChange(value) {
      this.province = value;

      request(
        "get",
        `${baseUrl.base_1}/ftaareainfo/queryAreaByFtaId/${this.province}`
      ).then((res) => {
        this.cityList = res.data;
        this.city = res.data[0].id;

        // return request('get', `/ftaInfoArea/queryAreaByAreaId/${this.city}`)
      });
      // .then((res) => {
      //   this.yearList = res.data
      //   this.year = res.data[0].id
      // })
    },

    // cityChange (value) {
    //   this.city = value
    //   request('get', `/ftaInfoArea/queryAreaByAreaId/${this.city}`).then(
    //     (res) => {
    //       this.yearList = res.data
    //       this.year = res.data[0].id
    //     }
    //   )
    // },
    fotItemBox() {
      const {
        introduction,
        indsStrategy,
        geography,
        strategicOrientation,
        publicFaci,
        climateCondition,
      } = this.information;
      this.pointList = [
        { name: "Provincial/Municipal FTZs", code: 0, id: "#Provincial" },
        { name: "Area Info", code: 1, id: "#industry" },
        { name: "Key Colleges and Universities", code: 2, id: "#economic" },
      ];
      let arr = [
        { name: "introduction", value: introduction },
        { name: "indsStrategy", value: indsStrategy },
        { name: "geography", value: geography },
        { name: "strategicOrientation", value: strategicOrientation },
        { name: "publicFaci", value: publicFaci },
        { name: "climateCondition", value: climateCondition },
      ].filter((fl) => !!fl.value);
      if (arr.length == 6) {
        // 显示两行 6 个
        arr.forEach((fc) => {
          this.information[fc.name] = fc.value;
        });
        this.isShowItem = 2;
      } else if (arr.length > 3) {
        // 显示 1 行
        this.information.introduction = [];
        this.information.indsStrategy = [];
        this.information.geography = [];
        this.information.strategicOrientation = [];
        this.information.publicFaci = [];
        this.information.climateCondition = [];

        this.isShowItem = 1;
        arr = arr.filter((fl) => fl.name != climateCondition);
        console.log(arr, 5554);
        this.information[arr[0].name] = arr[0].value;
        this.information[arr[1].name] = arr[1].value;
        this.information[arr[2].name] = arr[2].value;
      } else {
        // 直接隐藏
        this.pointList = [
          { name: "Provincial/Municipal FTZs", code: 0, id: "#Provincial" },
          // { name: "Area Info", code: 1, id: "#industry" },
          { name: "Key Colleges and Universities", code: 1, id: "#economic" },
        ];
        this.isShowItem = 0;
      }
    },

    handleClick() {
      request("get", `${baseUrl.base_1}/ftaareainfo/queryBy/${this.city}`).then(
        (res) => {
          this.isShow = 0;
          this.setDataByBasicInfo(res.data);
          // let cityName = ''
          this.cityList.forEach((item) => {
            if (item.id == this.city) {
              // cityName = item.val
              this.cityName = item.val;
              this.center = item.areaCoord.split(",");
              this.text = `<div style="position: relative;">
                      <div
                          style="background: #fff; padding: 8px 15px;box-shadow: 1px 1px 5px rgba(0,0,255,.5); ">
                          <p style="margin: 0; color: #000; font-size: 14px;">${
                            item.val
                          }</p>
                          <p style="margin: 0; color: #000; font-size: 12px;">
                             Foundation date:
                              <span style="color: #0073FF">
                                 ${
                                   item.establishDate
                                     ? item.establishDate
                                     : "No Data"
                                 }
                              </span>
                          </p>
                                   <p style="margin: 0; color: #000; font-size: 12px;">
                              Surface:
                              <span style="color: #0073FF">
                                  ${item.area ? item.area : "No Data"}${
                item.area ? "km²" : ""
              }
                              </span>
                          </p>
                      </div>
                      <div style="position: absolute; bottom: 0; left: 0; width: 100%; z-index: 3; height: 10px; background: #fff; border-radius: 4px;"></div>
                      <div style="position: absolute; bottom: -5px; left: 50%; z-index: 2; margin-left: -5px; width: 10px; height: 10px; background: #fff; transform: rotate(135deg); box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);"></div>
                  </div> `;
            }
          });
          this.getFtzNew();
        }
      );
    },

    setDataByBasicInfo(data) {
      if (!data) return;
      let {
        contactInfo,
        indsStrategy,
        introduction,
        geography,
        climateCondition,
        publicFaci,
      } = data.basicInfo;
      if (contactInfo && contactInfo.length) {
        contactInfo = contactInfo.split("&");
      }
      if (indsStrategy && indsStrategy.length) {
        indsStrategy = indsStrategy.split("、");
      }
      if (introduction && introduction.length) {
        introduction = introduction.split("&");
      }
      if (geography && geography.length) {
        geography = geography.split("&");
      }
      if (climateCondition && climateCondition.length) {
        climateCondition = climateCondition.split("&");
      }
      if (publicFaci && publicFaci.length) {
        publicFaci = publicFaci.split("&");
      }
      data.basicInfo.contactInfo = contactInfo;
      data.basicInfo.indsStrategy = indsStrategy;
      data.basicInfo.introduction = introduction;
      data.basicInfo.geography = geography;
      data.basicInfo.climateCondition = climateCondition;
      data.basicInfo.publicFaci = publicFaci;
      this.information = data.basicInfo;
      this.fotItemBox();
      this.setnag();
      data.innResourcesList.forEach((item, index) => {
        item.num = index + 1;
        // console.log(item,'1111')
        if (item.phoneNum != null) {
          item.phoneNum = item.phoneNum.toString().split("&");
        }
      });
      this.innovateList = data.innResourcesList;
      console.log(
        this.innovateList,
        "this.innovateListthis.innovateListthis.innovateList"
      );
      if (this.innovateList.length === 1) {
        if (
          this.innovateList[0].phoneNum === null &&
          this.innovateList[0].addr === null
        ) {
          this.flag = true;
        }
      }
      if (this.innovateList.length === 0) {
        this.flag = true;
      }
      this.setnag();
      // this.getList()
    },
    setnag() {
      if (!this.innovateList.length && !!this.information.contactInfo) {
        this.pointList = [
          { name: "Provincial/Municipal FTZs", code: 0, id: "#Provincial" },
          { name: "Area Info", code: 1, id: "#industry" },
          // { name: "Key Colleges and Universities", code: 2, id: "#economic" },
          { name: "Contact", code: 2, id: "#investment" },
        ];
      } else if (!this.information.contactInfo && !!this.innovateList.length) {
        this.pointList = [
          { name: "Provincial/Municipal FTZs", code: 0, id: "#Provincial" },
          { name: "Area Info", code: 1, id: "#industry" },
          { name: "Key Colleges and Universities", code: 2, id: "#economic" },
          // { name: "Contact", code: 3, id: "#investment" }
        ];
      } else if (!this.information.contactInfo && !this.innovateList.length) {
        this.pointList = [
          { name: "Provincial/Municipal FTZs", code: 0, id: "#Provincial" },
          { name: "Area Info", code: 1, id: "#industry" },
          // { name: "Key Colleges and Universities", code: 2, id: "#economic" },
          // { name: "Contact", code: 3, id: "#investment" }
        ];
      } else {
        this.pointList = [
          { name: "Provincial/Municipal FTZs", code: 0, id: "#Provincial" },
          { name: "Area Info", code: 1, id: "#industry" },
          { name: "Key Colleges and Universities", code: 2, id: "#economic" },
          { name: "Contact", code: 3, id: "#investment" },
        ];
      }
    },

    pageInit() {
      const TS02b1f2d3 = getCookieKey("TS02b1f2d3");
      this.$store.commit("ftaToken", TS02b1f2d3);

      const keyword = "policy"; //National FTZs // 全国自贸区

      // 获取省/直辖市下拉框信息
      request("get", `${baseUrl.base_1}/ftaareainfo/queryProvince`)
        .then((res) => {
          if (this.$route.query.provinceId) {
            this.provinceList = res.data;
            this.province = this.$route.query.provinceId;
          } else {
            this.provinceList = res.data;
            this.province = res.data[0].id;
          }

          // 获取市下拉框信息
          return request(
            "get",
            `${baseUrl.base_1}/ftaareainfo/queryAreaByFtaId/${this.province}`
          );
        })
        .then((res) => {
          if (this.$route.query.city) {
            this.cityList = res.data;
            this.city = this.$route.query.city;
            this.cityList.forEach((item) => {
              if (item.id === this.city) {
                this.cityName = item.val;
              }
            });
          } else {
            this.cityList = res.data;
            this.city = res.data[5].id;
            this.cityName = res.data[5].val;
          }
          this.getFtzNew();
          // 自贸区片区信息
          return request(
            "get",
            `${baseUrl.base_1}/ftaareainfo/queryBy/${this.city}`
          );
        })
        .then((res) => {
          // debugger
          this.isShow = 0;
          this.setDataByBasicInfo(res.data);
          this.cityList.forEach((value) => {
            if (value.id == this.city) {
              // cityName = item.val
              this.center = value.areaCoord.split(",");
              this.text = `<div style="position: relative;">
                      <div
                          style="background: #fff; padding: 8px 15px; ">
                          <p style="margin: 0; color: #000; font-size: 14px;font-weight: 600">${
                            value.val
                          }</p>
                          <p style="margin: 0; color: #000; font-size: 12px;">
                             Foundation date:
                              <span style="color: #0073FF">
                                ${
                                  value.establishDate
                                    ? value.establishDate
                                    : "No Data"
                                }
                              </span>
                          </p>
                                   <p style="margin: 0; color: #000; font-size: 12px;">
                              Surface:
                              <span style="color: #0073FF">
                                   ${value.area ? value.area : "No Data"}${
                value.area ? "km²" : ""
              }
                              </span>

                          </p>
                      </div>
                      <div style="position: absolute; bottom: 0; left: 0; width: 100%; z-index: 3; height: 10px; background: #fff; border-radius: 4px;"></div>
                      <div style="position: absolute; bottom: -5px; left: 50%; z-index: 2; margin-left: -5px; width: 10px; height: 10px; background: #fff; transform: rotate(135deg); box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);"></div>
                  </div> `;
            }
          });
        });
      // //   新闻
      // request("get", `${baseUrl.base_3}/api/tags/FTZ?page=1`)
      //   .then(res => {
      //     this.total = res.data.total;
      //     let list = res.data.content;
      //     list.forEach((item, index) => {
      //       item.num = index + 1;
      //       // item.keyword = item.catName
      //       item.keyword = this.keyword;
      //     });
      //     this.newsList = list;
      //   })
      //   .catch(err => {
      //     console.log(err, "err");
      //   });
    },
    // 获取自贸区新闻资讯
    getFtzNew() {
      this.$axios
        .get(
          `${baseUrl.base_2}/recommend/rest/2/0/0/${encodeURI(this.cityName)}`
        )
        .then((res) => {
          const data = res.data.results;
          data.map((el) => (el.id = el.resourceId.split("_")[1] || el.id));
          this.newsList = data;
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },
    getList() {
      request("get", `${baseUrl.base_1}/ftaareainfo/queryBy/${this.city}`).then(
        (res) => {
          const data = res.data.innResourcesList;
          data.forEach((item, index) => {
            item.num = index + 1;
          });
          this.innovateList = data;
          this.setnag();
        }
      );
    },
  },
  created() {},
  mounted() {
    var map_ter = new T.TileLayer(
      "http://t0.tianditu.gov.cn/vec_w/wmts?" +
        "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
        "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
        "&tk=ed564f9c0ee383bb453cd76d135c8fee"
    );

    var map_cta = new T.TileLayer(
      "http://t0.tianditu.gov.cn/eva_w/wmts?" +
        "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=eva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
        "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
        "&tk=ed564f9c0ee383bb453cd76d135c8fee"
    );
    this.$nextTick(() => {
      setTimeout(() => {
        let map = this.$refs.map.getMap();
        //  console.log(this.$refs.map.getMap(),777)

        map.addLayer(map_ter);
        map.addLayer(map_cta);
      }, 100);
    });

    this.pageInit();
    this.$eventBus.$on("changeData", (data) => {
      this.ponitShow = data.ponitShow;
      this.code = data.code;
    });
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
  computed: {
    published() {
      return function (data) {
        return `[${moment(data).format("YYYY-MM-DD")}]`;
      };
    },
  },
};
</script>

<style src="../fta.css"  scoped></style>
<style lang="less"  src="./FtaAreaInfo.less"  scoped></style>
<style scoped lang="less">
.mapDiv {
  position: relative;
}

.mapDiv > div:nth-of-type(1) {
  position: absolute;
  top: 20px;
  z-index: 1000;
  min-width: 177px;
  height: 31px;
  padding: 0px 10px;
  background-image: linear-gradient(
    90deg,
    #64d1ff 40%,
    rgba(52, 164, 255, 0.4) 100%
  );
}

.mapDiv > div:nth-of-type(1) > p {
  // font-family: SourceHanSansCN-Normal;
  font-size: 14px;
  color: #000000;
  letter-spacing: -0.28px;
  font-weight: 400;
  line-height: 31px;
  float: left;
  margin-left: 10px !important;
}
.point {
  position: fixed;
  right: 5%;
  top: 29.5%;
  background: #ffffff;
  border: 1px solid #c9e4ff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
  border-radius: 0 0 5px 5px;
  width: 123px;
  z-index: 1000;
  padding: 17px 13px 6px;
  &::before {
    content: "";
    background-image: linear-gradient(180deg, #51c9ff 0%, #89e5ff 100%);
    border-radius: 5px 5px 0 0;
    width: 123px;
    height: 8px;
    position: absolute;
    top: -8px;
    left: -1px;
  }
  > div {
    border-left: 1px solid #d7d7d7;
    > div {
      opacity: 0.3;
      // font-family: SourceHanSansCN-Regular;
      font-size: 12px;
      color: #000000;
      letter-spacing: -0.24px;
      font-weight: 400;
      text-indent: 9px;
      overflow: hidden;
      line-height: 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 90px;
      margin-bottom: 13px;
    }
    .active-scroll {
      // font-family: SourceHanSansCN-Regular;
      font-size: 12px;
      color: #208eff;
      letter-spacing: -0.24px;
      font-weight: 400;
      opacity: 1;
      border-left: 1px solid #2291fe;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 90px;
    }
  }
}
.titleMap {
  width: 142px;
  height: 43px;
  background: #ffffff;
  border: 1px solid #d0d0d0;
  border-radius: 2px;
  position: absolute;
  z-index: 1000;
  bottom: 15px;
  left: 25px;
  padding-left: 20px;
  box-sizing: border-box;
  line-height: 43px;
}
.titleMap img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
  margin-top: -2px;
}
.titleMap span {
  // font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  color: #000000;
  letter-spacing: -0.24px;
  font-weight: 400;
}
.titleMap span > :nth-of-type(1) {
  margin-right: 15px;
}
</style>
<style>
.tdt-pane.tdt-overlay-pane {
  z-index: 9999 !important;
}
.noData {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}
.tdt-labe {
  padding: 0 !important;
}
</style>
